module.exports = __webpack_public_path__ + "static/media/illuEuropraid2018_01_full.75a4dfd3.gif";